import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

const Impressum = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen gradient-mesh py-12 px-4">
      <div className="container mx-auto max-w-4xl">
        <Button
          variant="ghost"
          onClick={() => navigate(-1)}
          className="mb-8 hover:bg-primary/10"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Zurück
        </Button>

        <div className="prose prose-sm md:prose-base max-w-none">
          <h1 className="font-heading font-bold text-3xl md:text-4xl text-foreground mb-8">
            Impressum
          </h1>

          <section className="mb-8">
            <h2 className="font-heading font-semibold text-xl md:text-2xl text-foreground mb-4">
              Angaben gemäß § 5 TMG
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              Fuel72 ist eine Marke von:<br /><br />
              <strong>FUEGODROPS GmbH</strong><br />
              Sitz: Bad Honnef<br />
              53604 Bad Honnef<br />
              Deutschland
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-heading font-semibold text-xl md:text-2xl text-foreground mb-4">
              Handelsregister
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              Amtsgericht Siegburg, HRB 18191
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-heading font-semibold text-xl md:text-2xl text-foreground mb-4">
              Kontakt
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              E-Mail: hello@fuel72.com<br />
              WhatsApp: +49 176 87870011
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-heading font-semibold text-xl md:text-2xl text-foreground mb-4">
              Umsatzsteuer-ID
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
              Wird erteilt / In Bearbeitung
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-heading font-semibold text-xl md:text-2xl text-foreground mb-4">
              Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              FUEGODROPS GmbH<br />
              53604 Bad Honnef
            </p>
          </section>

          <section className="mb-8 p-6 rounded-xl border border-neon-cyan/30 bg-neon-cyan/5">
            <h2 className="font-heading font-semibold text-xl md:text-2xl text-foreground mb-4">
              Für US-Kunden / For US Customers
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              <strong>FUEGODROPS LLC</strong><br />
              State of Wyoming<br />
              United States
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-heading font-semibold text-xl md:text-2xl text-foreground mb-4">
              EU-Streitschlichtung
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
              <a
                href="https://ec.europa.eu/consumers/odr/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary hover:underline"
              >
                https://ec.europa.eu/consumers/odr/
              </a>
              <br />
              Unsere E-Mail-Adresse finden Sie oben im Impressum.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-heading font-semibold text-xl md:text-2xl text-foreground mb-4">
              Verbraucherstreitbeilegung/Universalschlichtungsstelle
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-heading font-semibold text-xl md:text-2xl text-foreground mb-4">
              Haftung für Inhalte
            </h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten
              nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
              Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
              Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
              Tätigkeit hinweisen.
            </p>
            <p className="text-muted-foreground leading-relaxed">
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den
              allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch
              erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei
              Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend
              entfernen.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-heading font-semibold text-xl md:text-2xl text-foreground mb-4">
              Haftung für Links
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen
              Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr
              übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder
              Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der
              Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum
              Zeitpunkt der Verlinkung nicht erkennbar.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-heading font-semibold text-xl md:text-2xl text-foreground mb-4">
              Urheberrecht
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten
              unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung
              und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
              schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien
              dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Impressum;
